import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import type { SxProps } from "@mui/material";
import { Box, Grid, IconButton, Typography } from "@mui/material";
import HorizontalFill from "../HorizontalFill";

interface Props {
  text: string;
  disabled?: boolean;
  onClose: () => void;
  sx?: SxProps;
}
export default function PromptDialogHeader({ text, disabled, onClose, sx }: Props) {
  return (
    <Grid container sx={{ px: 3, py: 2, alignItems: "center", flexWrap: "nowrap", width: "100%", ...sx }}>
      <Typography component={"span"} variant="h6" noWrap sx={{ minWidth: 0 }}>
        {text}
      </Typography>
      <HorizontalFill />
      <Box>
        <IconButton disabled={disabled} onClick={onClose} sx={{ width: 20, height: 20 }}>
          <CloseRoundedIcon fontSize="small" />
        </IconButton>
      </Box>
    </Grid>
  );
}
